"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadReport = exports.findAvailableOrders = exports.ReportType = void 0;
const core_1 = require("./core");
const search_1 = require("./search");
var ReportType;
(function (ReportType) {
    ReportType[ReportType["REL_LOG_COMUNICACAO"] = 0] = "REL_LOG_COMUNICACAO";
    ReportType[ReportType["REL_FORNECEDOR_OPE"] = 1] = "REL_FORNECEDOR_OPE";
    ReportType[ReportType["REL_COMPRADOR_OPE"] = 2] = "REL_COMPRADOR_OPE";
    ReportType[ReportType["REL_MATCH"] = 3] = "REL_MATCH";
    ReportType[ReportType["REL_USUARIO"] = 4] = "REL_USUARIO";
    ReportType[ReportType["REL_INSCRICAO_EVENTO"] = 5] = "REL_INSCRICAO_EVENTO";
})(ReportType = exports.ReportType || (exports.ReportType = {}));
const ORDER_ACTIONS = {
    [ReportType.REL_LOG_COMUNICACAO]: "ordRelLogComunicacao",
    [ReportType.REL_FORNECEDOR_OPE]: "ordRelFornecedorOpe",
    [ReportType.REL_COMPRADOR_OPE]: "ordRelCompradorOpe",
    [ReportType.REL_MATCH]: "ordRelMatch",
    [ReportType.REL_USUARIO]: "ordRelUsuario",
    [ReportType.REL_INSCRICAO_EVENTO]: "ordRelInscricaoEvento",
};
const REPORT_ACTIONS = {
    [ReportType.REL_LOG_COMUNICACAO]: 'relatorioLogComunicacao',
    [ReportType.REL_FORNECEDOR_OPE]: 'relatorioFornecedor',
    [ReportType.REL_COMPRADOR_OPE]: 'relatorioComprador',
    [ReportType.REL_MATCH]: 'relatorioMatch',
    [ReportType.REL_USUARIO]: 'relatorioUsuario',
    [ReportType.REL_INSCRICAO_EVENTO]: 'relatorioInscricaoEvento',
};
function findAvailableOrders(reportType) {
    return core_1.get('ordenacao', ORDER_ACTIONS[reportType])
        .then(({ dados }) => dados.map(dado => ({
        name: dado.nome,
        field: dado.campo
    })));
}
exports.findAvailableOrders = findAvailableOrders;
function downloadReport(reportType, search) {
    const encodedSearch = search_1.encodeSearchValues(search);
    return core_1.downloadFile('Relatorios', REPORT_ACTIONS[reportType], Object.assign({}, encodedSearch));
}
exports.downloadReport = downloadReport;
